import React from "react";
import {Link} from "react-router-dom";
import listIcon from "../../assets/images/icons/logo_icon.svg";

const items = [
    {
        title: "Innowacyjna platforma",
        text: "W GO-auto znajdziesz auta od sprawdzonych dostawców, dealerów i partnerów flotowych. To samochody nowe lub używane, zweryfikowane pod kątem stanu, dostępności i warunków zakupu.",
    },
    {
        title: "Potężna baza aut",
        text: "Curabitur maximus nunc eget nunc imperdiet, ut commodo nisl volutpat. Nullam tempor magna vitae leo ornare, at iaculis ex consectetur.",
    },
    {
        title: "Wygodne finansowanie",
        text: "Curabitur maximus nunc eget nunc imperdiet, ut commodo nisl volutpat. Nullam tempor magna vitae leo ornare, at iaculis ex consectetur.",
    },
];

function HomePromo() {
    return (
        <section className="home-promo">
            <div className="home-promo-card">
                <div className="home-promo-text">
                    <div className="home-promo-content">
                        <h2 className="home-promo-heading">Samochody nowe i używane w atrakcyjnych warunkach</h2>
                        <ul className="home-promo-list">
                            <p className="home-promo-item-text">W GO-auto znajdziesz auta od sprawdzonych dostawców, dealerów i partnerów flotowych. To samochody nowe lub używane, zweryfikowane pod kątem stanu, dostępności i warunków zakupu.

                                Przy wybranych modelach możesz sprawdzić szacowaną ratę, dostępne rabaty i formę finansowania dopasowaną do budżetu. Jeśli auto spełnia Twoje oczekiwania, doradca pomoże przejść do konkretnej propozycji.</p>

                        </ul>
                    </div>
                    <Link to="/lista-ofert" className="home-promo-btn">
                        Zobacz więcej
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="10" cy="10" r="9.5" stroke="#176fb7"/>
                            <path d="M8.5 6.5L12 10L8.5 13.5" stroke="#176fb7" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </Link>
                </div>
                <div className="home-promo-image">
                    <img src="/img/home_1.png" alt="GO Auto"/>
                </div>
            </div>
        </section>
    );
}

export default HomePromo;
